import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header-1',
  imports: [CommonModule],
  templateUrl: './header-1.html',
  styleUrl: './header-1.scss'
})
export class Header1 {

}
